import { useTranslation } from "react-i18next";

export default function ContactUs() {
  const { t } = useTranslation();

  return (
    <div className="bg-[#F2F6FB] py-16 relative ">
      <div className="px-8 md:px-28 md:space-x-16 md:my-16 mx-4 md:mx-0 space-y-16 relative z-10">
        <p className="text-left leading-[50px] text-[50px] font-normal text-[#222222]">
          {t("ContactUsPage.main.title")}
        </p>
        <div className="md:flex justify-between space-y-8 md:space-y-0">
          <div className="space-y-8 w-full">
            <div className="flex items-center space-x-3">
              <img
                className="w-[32px] h-[32px]"
                src="/assets/svg/mail.svg"
                alt="Email"
                loading="lazy"
                decoding="async"
              />
              <div className="text-left">
                <a href="mailto:ventas@sisacero.com">ventas@sisacero.com</a>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <img
                className="w-[32px] h-[32px]"
                src="/assets/svg/location.svg"
                alt="Location"
                loading="lazy"
                decoding="async"
              />
              <p className="text-left">
                Industriales 214, Parque Industrial del Norte. Km 4.5 Carretera
                <br />
                Monterrey – Salinas Victoria, Salinas Victoria N.L
              </p>
            </div>
          </div>

          <div className="w-full space-y-2">
            <div className="flex md:justify-center w-full items-start gap-4">
              <img
                className="w-[32px] h-[32px]"
                src="/assets/svg/phone.svg"
                alt="Phone"
                loading="lazy"
                decoding="async"
              />
              <div className="space-y-4 text-left">
                <p>
                  <a href="tel:(81) 1871 7770 al 72">(81) 1871 7770 al 72</a>
                </p>
                <p>
                  <a href="tel:(81) 8369 4780 al 83">(81) 8369 4780 al 83</a>
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-8 w-full">
            <div className="flex items-center space-x-3">
              <img
                className="w-[32px] h-[32px]"
                src="/assets/svg/whatsapp.svg"
                alt="Whatsapp"
                loading="lazy"
                decoding="async"
              />
              <div className="text-left">
                <a href="https://wa.me/8115135735">(81) 1513 5735</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
